import { SolutionTypeEnum } from "@/services/solutions/types";

export interface Contract{
    id: string,
    name: string,
    number: string,
    licences: Licences
}

// export interface Licences {}

export interface Licences {
    information : number,
    guestRegistration: number,
    meet: number,
    wall: number,
    poster: number,
    sessions: number,
    calmviso: number
}

export interface ContractDto{
    id: string,
    licences: {}
}

export interface LicenceType{
    information: {
        informationScreen: SolutionTypeEnum.informationScreen,
        receptionScreen: SolutionTypeEnum.receptionScreen,
        meetingOverview: SolutionTypeEnum.meetingOverview,
        interactiveInformationScreen: SolutionTypeEnum.interactiveInformationScreen,
        wayfinder: SolutionTypeEnum.wayfinder
    },
    guestRegistration: {
        guestRegistration: SolutionTypeEnum.guestRegistration
    },
    meet: {
        meetingRoomScreen: SolutionTypeEnum.meetingRoomScreen
    },
    wall: {
        screenWall: SolutionTypeEnum.screenWall,
        supernovaWall: SolutionTypeEnum.supernovaWall
    },
    poster: {
        digitalPoster: SolutionTypeEnum.digitalPoster
    },
    sessions: {
        sessions: SolutionTypeEnum.sessions
    },
    calmviso: {
        calmviso: SolutionTypeEnum.calmviso
    }
}

export const LicenceTypes = {
    information: {
        informationScreen: SolutionTypeEnum.informationScreen,
        receptionScreen: SolutionTypeEnum.receptionScreen,
        meetingOverview: SolutionTypeEnum.meetingOverview,
        interactiveInformationScreen: SolutionTypeEnum.interactiveInformationScreen,
        wayfinder: SolutionTypeEnum.wayfinder
    },
    guestRegistration: {
        guestRegistration: SolutionTypeEnum.guestRegistration
    },
    meet: {
        meetingRoomScreen: SolutionTypeEnum.meetingRoomScreen
    },
    wall: {
        screenWall: SolutionTypeEnum.screenWall,
        supernovaWall: SolutionTypeEnum.supernovaWall
    },
    poster: {
        digitalPoster: SolutionTypeEnum.digitalPoster
    },
    sessions: {
        sessions: SolutionTypeEnum.sessions
    },
    calmviso: {
        calmviso: SolutionTypeEnum.calmviso
    }
} as LicenceType;
